import { FormControl } from '@mui/joy';

import { ReactNode } from 'react';

import SliderWithInput from '@/components/SliderWithInput';
import { cn } from '@/utils/tailwind';

import {
  ManifestVariant,
  tableVariantLabelClass,
  tableVariantRowClass,
} from './Manifest.utils';

export function ManifestSlider(props: {
  title?: ReactNode;
  description?: ReactNode;
  value?: number | null;
  defaultValue?: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number | null) => void;
  // does not show slider
  readOnly?: boolean;
  // shows slider but in disabled state
  disabled?: boolean;
  disabledMessage?: string;
  variant: ManifestVariant;
  inputPosition?: 'top' | 'right';
  checked?: boolean;
  onCheckChange?: (checked: boolean) => void;
}) {
  const defaultStr = props.defaultValue?.toString() ?? '';

  if (props.readOnly) {
    return (
      <div
        className={cn(
          'flex flex-col items-stretch gap-2',
          props.variant === 'table' && tableVariantRowClass
        )}
      >
        <span
          className={cn(
            'my-auto text-sm font-medium',
            props.variant === 'table' && tableVariantLabelClass
          )}
        >
          {props.title}
        </span>

        <div className="overflow-hidden text-ellipsis">
          {props.value?.toString() ?? defaultStr}
        </div>
      </div>
    );
  }

  return (
    <FormControl sx={{ gap: 0 }}>
      <SliderWithInput
        title={props.title}
        description={props.description}
        value={props.value ?? props.defaultValue ?? 0}
        min={props.min}
        max={props.max}
        step={props.step}
        onChange={(newValue) => props.onChange(newValue)}
        disabled={props.disabled}
        disabledMessage={props.disabledMessage}
        inputPosition={props.inputPosition}
        checked={props.checked}
        onCheckChange={props.onCheckChange}
      />
    </FormControl>
  );
}
